import React from 'react';
import { motion } from 'framer-motion';
import { LifeBuoyIcon, SparklesIcon, TargetIcon, TrendingUpIcon, TrophyIcon } from 'lucide-react';
import { bonuses, type Bonus } from '../data/bonuses';
const icons: Record<Bonus['icon'], typeof TargetIcon> = {
  target: TargetIcon,
  lifebuoy: LifeBuoyIcon,
  spotlight: TrophyIcon,
  games: SparklesIcon,
  growth: TrendingUpIcon
};
export function BonusSection() {
  return <section className="border-y border-acad-line bg-acad-sand/55 px-4 py-20 sm:py-28" data-id="element-18" data-mp="1aoyxvsktles5">
      <div className="mx-auto max-w-6xl" data-id="element-19" data-mp="15qno1huiz49x">
        <div className="mx-auto max-w-3xl text-center" data-id="element-20" data-mp="15njdm2qgvcat">
          <p className="text-sm font-bold uppercase tracking-[0.16em] text-acad-gold" data-id="element-21" data-mp="1jhkfh5cptffe">
            Included at no additional cost
          </p>
          <h2 className="mt-3 font-display text-4xl font-semibold text-acad-ink sm:text-5xl" data-id="element-22" data-mp="1eo7porwav2l2">
            The 5 Premium Bonuses
          </h2>
          <p className="mt-4 text-base leading-7 text-acad-muted" data-id="element-23" data-mp="mxtj7gqm8sjf">
            Every bonus solves a different problem Tap Dance instructors face
            outside the core lesson system.
          </p>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-2" data-id="element-24" data-mp="2epv26urcqfpx">
          {bonuses.map((bonus, index) => {
          const Icon = icons[bonus.icon];
          return <motion.article key={bonus.id} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.1
          }} transition={{
            duration: 0.28,
            delay: index % 2 * 0.06,
            ease: [0.23, 1, 0.32, 1]
          }} className={`flex h-full flex-col rounded-2xl border border-acad-line bg-white p-6 shadow-card sm:p-8 ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-25" data-mp="2oh8ykto0azeu" data-mpi={index}>
                <div className="flex items-center justify-between gap-3" data-id="element-26" data-mp="1h23xvn775xdh">
                  <span className="flex h-12 w-12 items-center justify-center rounded-xl border border-acad-gold/50 bg-acad-goldSoft text-acad-goldDark" data-id="element-27" data-mp="1c4u0nldkghf3">
                    <Icon size={22} aria-hidden="true" data-id="element-28" data-mp="1q1zcy33vicis" />
                  </span>
                  <span className="rounded-full border border-acad-gold/50 bg-acad-canvas px-3 py-1 text-xs font-bold tracking-[0.1em] text-acad-goldDark" data-id="element-29" data-mp="1m2zz1t05z5f7">
                    BONUS {bonus.id}
                  </span>
                </div>
                <h3 className="mt-5 font-display text-2xl font-semibold leading-tight text-acad-ink sm:text-3xl" data-id="element-30" data-mp="1757nfbxqn16a">
                  {bonus.title}
                </h3>
                <p className="mt-3 border-l-2 border-acad-gold pl-4 text-sm font-medium leading-6 text-acad-goldDark" data-id="element-31" data-mp="12d7qztgvmqeg">
                  {bonus.subtitle}
                </p>
                <p className="mt-5 text-sm leading-6 text-acad-muted" data-id="element-32" data-mp="am9xwoall3sg">
                  {bonus.description}
                </p>
                <p className="mt-6 text-xs font-bold uppercase tracking-[0.13em] text-acad-muted" data-id="element-33" data-mp="i3arq9js7y1">
                  {bonus.listLabel}
                </p>
                <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-34" data-mp="3mre3f4u8jtv3">
                  {bonus.bullets.map(bullet => <li key={bullet} className="flex gap-2 text-sm leading-6 text-acad-muted" data-id="element-35" data-mp="3rqh82o6azy2j">
                      <span className="text-acad-gold" aria-hidden="true" data-id="element-36" data-mp="o8p8oopu8bub">
                        ✦
                      </span>
                      {bullet}
                    </li>)}
                </ul>
                <div className="mt-auto pt-7" data-id="element-37" data-mp="e9rofxzg34h4">
                  <p className="rounded-xl border border-acad-gold/45 bg-acad-goldSoft/50 p-4 text-sm font-semibold leading-6 text-acad-ink" data-id="element-38" data-mp="ecm99qmderb2">
                    {bonus.payoff}
                  </p>
                </div>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}